import { isAllQuarters } from '@/api/hcp/partnerscore/utils';
import { Dispatch, SetStateAction } from 'react';
import { SortDirection } from '../components/TableHeader/utils/TableHeaderTypes';
import { ScoreData } from '../PartnerScoreDataAvailabilityTypes/PartnerScoreDataAvailabilitytypes';

export const hasDataForYear = (filteredPartnerScore: ScoreData[], year: number, quarter: number) => {
  if (isAllQuarters(quarter)) {
    return filteredPartnerScore.some(score => score.year === year);
  }
  return filteredPartnerScore.some(score => score.year === year && score.quarter === quarter);
};

export const handleHideClick = (isTableVisible: boolean, setTableVisible: Dispatch<SetStateAction<boolean>>) => {
  setTableVisible(!isTableVisible);
};

export const handleSort = (
  setSortConfig: React.Dispatch<React.SetStateAction<{ key: string; direction: SortDirection }>>,
) => {
  setSortConfig(prevConfig => ({
    key: prevConfig.key,
    direction: prevConfig.direction === SortDirection.Asc ? SortDirection.Desc : SortDirection.Asc,
  }));
};
